module.exports = __webpack_public_path__ + "92ec9f8cf4964092134ca240e7b20c95.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-3.png
// module id = 2193
// module chunks = 0